export default "__VITE_ASSET__I6R8_Lzs__"